<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{title}}</h1>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12>
        <div v-if="pointTreeData.length > 0">
          <tree
              :data="pointTreeData"
              :options="{
                fetchData(node) {
                  if (node.children.length > 0) {
                    return blank()
                  } else {
                    return getPointFolder(node.data.id)
                  }
                }
              }"
              class="tree--small"
          >
            <span class="tree-text body-2 ma-0 pa-0" slot-scope="{ node }">
              <template v-if="!node.hasChildren()">
                {{ node.text }}
                <span v-if="mode === 'active'">
                  <v-btn
                      flat
                      icon
                      small
                      class="ml-2 my-0 pa-0"
                      @click="editPoint(node)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn
                      flat
                      icon
                      small
                      class="ma-0 pa-0"
                      @click="deletePoint(node.data.id)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </span>
                <span v-if="mode === 'archive'">
                  <v-btn
                      flat
                      icon
                      small
                      class="ma-0 pa-0"
                      @click="activatePoint(node.data.id)"
                  >
                    <v-icon>check_box</v-icon>
                  </v-btn>
                </span>
              </template>

              <template v-else>
                {{ node.text }}
              </template>
            </span>
          </tree>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
        v-if="mode === 'active'"
    >
      <v-card>
        <v-card-title class="headline">Удалить торговую точку?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deletePointConfirm(deletePointId)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deletePointCancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="activateDialog"
        max-width="300"
        v-if="mode === 'archive'"
    >
      <v-card>
        <v-card-title class="headline">Восстановить торговую точку?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="primary"
              @click="activatePointConfirm(activatePointId)"
          >
            Восстановить
          </v-btn>

          <v-btn
              @click="activatePointCancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import HelpMixin from '../../mixins/help'

  export default {
    mixins: [HelpMixin],
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Торговые точки'}
        ],
        pageDataReady: {
          isReady: false,
          points: false
        },
        mode: 'active',
        title: 'Активные торговые точки',
        pointTreeData: [],
        pointIdCounter: 0,
        deleteDialog: false,
        deletePointId: null,
        activateDialog: false,
        activatePointId: null
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.points) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      editPoint (node) {
        this.$router.push('/points/edit/' + node.data.id)
      },
      deletePoint (id) {
        this.deleteDialog = true
        this.deletePointId = id
      },
      deletePointCancel () {
        this.deleteDialog = false
        this.deletePointId = null
      },
      deletePointConfirm () {
        this.$store.dispatch('deletePoint', {id: this.deletePointId})
          .then(() => {
            this.onCreated()
          })
          .catch(() => {})
      },
      activatePoint (id) {
        this.activateDialog = true
        this.activatePointId = id
      },
      activatePointCancel () {
        this.activateDialog = false
        this.activatePointId = null
      },
      activatePointConfirm () {
        this.$store.dispatch('activatePoint', {id: this.activatePointId})
          .then(() => {
            this.onCreated()
          })
          .catch(() => {})
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)
        this.deleteDialog = false
        this.deletePointId = null
        this.activateDialog = false
        this.activatePointId = null
        this.pointIdCounter = 0
        this.pointTreeData = []
        if (~this.$router.currentRoute.path.indexOf('/points/active')) {
          this.mode = 'active'
          this.title = 'Активные торговые точки'
        } else if (~this.$router.currentRoute.path.indexOf('/points/archive')) {
          this.mode = 'archive'
          this.title = 'Архив торговых точек'
        }
        this.$store.commit('setPageTitle', this.title)

        this.getPointFolder(0)
          .then((data) => {
            this.pointTreeData = [data[0]]
            this.pageDataReady.points = true
            this.pageDataStatus()
          })
          .catch(() => {})
      },
      async getPointFolder (nodeId) {
        let folder = []
        await this.$store.dispatch('getPointFolderList', {id: nodeId, mode: this.mode})
          .then((data) => {
            for (let i = 0; i < data.point_folder_list.length; i++) {
              folder.push({
                text: data.point_folder_list[i].title,
                data: {
                  id: data.point_folder_list[i].id,
                  type: 'folder',
                  children: []
                },
                id: this.pointIdCounter++,
                isBatch: data.point_folder_list[i].have_children
              })
            }
            for (let i = 0; i < data.point_list.length; i++) {
              folder.push({
                text: data.point_list[i].title,
                data: {
                  id: data.point_list[i].id,
                  type: 'point',
                  pointData: data.point_list[i]
                },
                id: this.pointIdCounter++
              })
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return folder
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Points/PointList.vue